import ZoomServices from "../../../services/ZoomServices";
import { getValidZoomAccessToken } from "../Auth/ZoomAuthHelper";

const ZoomProvider = {
  async getValidAccessToken() {
    return getValidZoomAccessToken();
  },

  async createMeeting(payload) {
    const token = await this.getValidAccessToken();
    if (!token) throw new Error("Zoom not authenticated");
    
    return ZoomServices.createUserMeeting(payload);
  },

  async getUpcomingMeetings() {
    return ZoomServices.getUpcomingMeetings();
  },

  async deleteMeeting(meetingId) {
    return ZoomServices.deleteMeeting(meetingId);
  },

  async deleteExpiredMeetings() {
    return ZoomServices.deleteExpiredMeetings();
  },

  getName() {
    return "Zoom";
  }
};

export default ZoomProvider;
